export class SubAttribute{
    subLotNo: string;
    constructor(subLotNo: string) { 
        this.subLotNo = subLotNo; 
    }
}